import type { JSX } from 'react'

export const FloatingVideoIcon = (): JSX.Element => (
  <use href='#floatingVideoIcon' height='100%' width='100%' />
)
